import { formatPrice, categoryOf } from "@/lib/store";
import { findPrice } from "@/lib/orderPrices";
import { TRADE_CATEGORIES, orderModels, NO_STORAGE } from "@/lib/tradeCatalog";
import { ModelPicker } from "../ModelPicker";
import { Choices, tradeInput } from "./TradeParts";

export const ORDER_OPTION = "__pedido";

// Preço do aparelho que o cliente quer: o do estoque, ou a média da faixa sugerida do "Fazer pedido".
export const wantedInfo = (f, products, orderPrices) => {
  if (f.wanted_product_id === ORDER_OPTION) {
    const w = f.wanted_order;
    const band = w?.model && w?.storage ? findPrice(orderPrices, w.model, w.storage, w.condition) : null;
    return { order: true, price: band ? (Number(band.min) + Number(band.max)) / 2 : 0, ready: !!(w?.model && w?.storage) };
  }
  const p = products.find((x) => x.id === f.wanted_product_id);
  return p ? { order: false, price: Number(p.price) || 0, ready: true } : null;
};

const OrderPick = ({ f, setF, info, sfx }) => {
  const w = f.wanted_order;
  const category = w.category || f.category;
  const models = orderModels(category);
  const entry = models.find((m) => m.name === w.model);
  const setW = (patch) => setF((s) => ({ ...s, wanted_order: { ...s.wanted_order, ...patch } }));
  const pickModel = (name) => {
    const m = models.find((x) => x.name === name);
    setW({ category, model: name, storage: m.storages.includes(w.storage) ? w.storage : m.storages[0], condition: m.conditions.some(([c]) => c === w.condition) ? w.condition : m.conditions[0][0] });
  };
  return (
    <div data-testid={`trade-wanted-order${sfx}`} className="mt-3 space-y-3 rounded-2xl border border-white/10 p-3">
      <Choices testid={`trade-wanted-category${sfx}`} value={category} options={TRADE_CATEGORIES.map((c) => [c.id, c.label])}
        onChange={(c) => setW({ category: c, model: "", storage: "", condition: "novo" })} />
      <ModelPicker key={category} testid={`trade-wanted-model${sfx}`} value={w.model} onChange={pickModel} options={models.map((m) => m.name)} selectOnly
        groupOf={(o) => models.find((m) => m.name === o)?.group} placeholder="Escolha o aparelho que você quer" className={tradeInput} />
      {entry && entry.storages[0] !== NO_STORAGE && <Choices testid={`trade-wanted-storage${sfx}`} value={w.storage} options={entry.storages.map((s) => [s, s])} onChange={(storage) => setW({ storage })} />}
      {entry && <Choices testid={`trade-wanted-condition${sfx}`} value={w.condition} options={entry.conditions} onChange={(condition) => setW({ condition })} />}
      {info?.ready && (
        <p data-testid={`trade-wanted-suggested${sfx}`} className="text-sm text-zinc-200">
          {info.price > 0 ? <>Preço sugerido em média: <strong className="text-white">{formatPrice(info.price)}</strong></> : "Preço sob consulta para essa configuração."}
        </p>
      )}
    </div>
  );
};

export const TradeWanted = ({ f, setF, products, info, sfx = "", label = "Qual aparelho você quer levar? (opcional)" }) => {
  const options = products.filter((p) => categoryOf(p) !== "acessorios" && Number(p.price) > 0);
  return (
    <div className="mt-5">
      <label className="block">
        <span className="mb-1.5 block text-xs text-zinc-400">{label}</span>
        <select data-testid={`trade-wanted-select${sfx}`} value={f.wanted_product_id} onChange={(e) => setF((s) => ({ ...s, wanted_product_id: e.target.value }))} className={tradeInput}>
          <option value="" className="bg-zinc-900">Ainda não sei</option>
          {options.length > 0 && (
            <optgroup label="Disponíveis na loja" className="bg-zinc-900">
              {options.map((p) => (
                <option key={p.id} value={p.id} className="bg-zinc-900">{`${[p.model, p.storage, p.color].filter(Boolean).join(" · ")} — ${formatPrice(p.price)}`}</option>
              ))}
            </optgroup>
          )}
          <option value={ORDER_OPTION} className="bg-zinc-900">Outro aparelho (sob encomenda)</option>
        </select>
      </label>
      {f.wanted_product_id === ORDER_OPTION && <OrderPick f={f} setF={setF} info={info} sfx={sfx} />}
    </div>
  );
};
